export default {
    root: {
        padding: '15px 15px 0px'
    },
};
